import { Col, Form, Row } from "antd";
import React, { useEffect } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../../components/utils/utils";
import {
  addScolarshipUniversity,
  getAllUniversitiesScholarship,
} from "../../../../apis/actions/scholarship.actions";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { useState } from "react";
import { setResModel, setResIds } from "../../../../apis/slices/ratingSlice";

interface AddRegistrationRequestProps {
  universities: any;
  beneficiary: any;
  setIsModalVisible: (v: boolean) => void;
  isModalVisible: boolean;
}

const AddRegistrationRequest = ({
  universities,
  beneficiary,
  setIsModalVisible,
  isModalVisible,
}: AddRegistrationRequestProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    form.resetFields();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          graduation_certificate_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  const onFinish = async () => {
    try {
      await form.validateFields();
      setIsSubmitting(true);
      const FormValues = form.getFieldsValue();

      const requestsFormData = {
        ...FormValues,
        partner_id: form.getFieldValue("partner_id").value,
        university_id: form.getFieldValue("university_id").value,
      };

      dispatch(addScolarshipUniversity(requestsFormData)).then(
        (result: any) => {
          const request = result?.payload?.result;
          if (request?.code === 200) {
            dispatch(setResModel(request?.res_model));
            dispatch(setResIds([request?.scholarship_application_id]));
            showNotitfication(request?.message, "success", dispatch);
            form.resetFields();
            setIsModalVisible(false);
            dispatch(getAllUniversitiesScholarship({ limit: 8, page: 1 }));
          } else {
            showNotitfication(result?.payload?.error?.data?.message, "error");
            setIsModalVisible(false);
          }
          setIsSubmitting(false);
        }
      );
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    }
  };

  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      modalStyle={{ top: 200 }}
    >
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إنشاء طلب منحة جامعية</p>
      </Row>
      <Form
        dir="rtl"
        form={form}
        layout="vertical"
        style={{ paddingTop: "1.5rem" }}
      >
        <Row gutter={16}>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="partner_id"
              label="المستفيد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Selects
                options={beneficiary}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="high_school_speciality"
              label="التخصص بالثانوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="accumulated_rate"
              label="معدل التراكمي"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="skills_rate"
              label="معدل القدرات"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="achievement_rate"
              label="المعدل التحصيلي"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="calculated_rate"
              label="المعدل النسبة الموزونة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="graduation_certificate_ids"
              label="الشهادة الجامعية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <UploadInput
                accept="*"
                text="الشهادة الجامعية"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="university_id"
              label="الجامعة التي تم القبول عليها"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Selects
                options={universities}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="request_number"
              label="رقم الطلب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              disabled={isSubmitting}
              loading={isSubmitting}
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إرسال"
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default AddRegistrationRequest;
